export default "__VITE_ASSET__9905069e__"